import "core-js/modules/es.array.concat.js";
import styled from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-19dx0pn-0"
})(["", ""], function (_ref) {
  var sticky = _ref.sticky,
    fixed = _ref.fixed,
    bottomMargin = _ref.bottomMargin;
  return (sticky || fixed) && "\n    z-index: 20;\n    bottom: 20px;\n\n    ".concat(fixed ? "position: fixed; left: 50%; transform: translateX(-50%);" : '', "\n    ").concat(sticky ? "position: sticky; z-index: 350; ".concat(bottomMargin ? 'margin-bottom: 72px;' : '') : '', "\n  ");
});